import { useTranslation } from "react-i18next";

const valueKeys = [
  { key: "positivity", icon: "ri-sun-line", color: "from-orange-400 to-yellow-400" },
  { key: "authenticity", icon: "ri-shield-check-line", color: "from-green-500 to-emerald-400" },
  { key: "inclusion", icon: "ri-heart-line", color: "from-pink-500 to-rose-400" },
  { key: "panafrican", icon: "ri-earth-line", color: "from-teal-500 to-cyan-400" },
  { key: "innovation", icon: "ri-lightbulb-line", color: "from-purple-500 to-violet-400" },
  { key: "community", icon: "ri-community-line", color: "from-amber-500 to-orange-400" },
];

export default function ValuesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="w-10 h-1 rounded-full bg-orange-500 mx-auto mb-3"></div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 font-serif">{t("apropos.values.title")}</h2>
          <p className="text-gray-500 mt-2 max-w-xl mx-auto">
            {t("apropos.values.subtitle")}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {valueKeys.map((v) => (
            <div
              key={v.key}
              className="group bg-[#fdf8f3] rounded-2xl p-5 md:p-7 border border-gray-100 hover:border-orange-200 hover:-translate-y-1 transition-all duration-300"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-gradient-to-br ${v.color} mb-4 md:mb-5`}>
                <i className={`${v.icon} text-white text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2 md:mb-3 group-hover:text-orange-500 transition-colors">
                {t(`apropos.values.${v.key}.title`)}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">{t(`apropos.values.${v.key}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
